class CustomQuiz extends HTMLElement {
  constructor() {
    super();

    this.id = this.dataset.quizId;
    this.graphqlId = this.dataset.graphqlId;
    this.handle = this.dataset.quizHandle;
    this.type = this.dataset.quizType;
    this.myshopify = this.dataset.myshopify;

    this.openQuizButtons = document.querySelectorAll(
      `.open-quiz-button[data-quiz-handle='${this.handle}']`
    );
    this.closeButton = this.querySelector("[data-close]");

    this.setupOpenClose();

    this.questionCards = this.querySelectorAll(".quiz-question-card");

    this.progressBar = this.querySelector(".quiz-overlay-head-progress");
    this.progressBarStepLabel = this.querySelector(
      ".quiz-overlay-head-progress-step span"
    );

    this.submitButton = this.querySelector(".quiz-submit-button");


    this.submitUrl = "https://nvh-quiz.up.railway.app/submit";

    this.emailPoup = this.querySelector("custom-quiz-email-card");
  }

  setupOpenClose() {
    this.openQuizButtons.forEach((openButton) => {
      openButton.addEventListener("click", () => {
        this.selectQuestion(0);
        this.toggle();
      });
    });

    this.closeButton.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    const currentState = this.dataset.open === "true";
    this.setAttribute("data-open", !currentState);
  }

  selectQuestion(index) {
    this.emailPoup.close();
    this.getCurrentActiveQuestion()?.setAttribute("data-active", false);

    const newActive = this.questionCards[index];
    newActive.setAttribute("data-active", "transition");
    setTimeout(() => {
      newActive.setAttribute("data-active", true);
    }, 50);

    let progressPercentage = (index + 1) / this.questionCards.length;
    progressPercentage = progressPercentage * 100 - 5;
    this.progressBar.setAttribute(
      "style",
      `--progress-percentage: ${progressPercentage}%`
    );

    this.progressBarStepLabel.textContent = `${index + 1}/${
      this.questionCards.length
    }`;
    this.progressBarStepLabel.setAttribute("data-active", true);
  }

  next() {
    console.log(this)
    const questionCount = this.questionCards.length;
    const currentActiveIndex = this.getCurrentActiveQuestionIndex();

    console.log(questionCount, currentActiveIndex)
    this.questionCards.forEach(card => {
      console.log(card)
    })

    if (currentActiveIndex + 1 >= questionCount) {
      this.submit();
      return;
    }

    this.selectQuestion(currentActiveIndex + 1);
  }

  previous() {
    let newIndex = this.getCurrentActiveQuestionIndex();
    newIndex = newIndex - 1;
    if (newIndex < 0) {
      this.toggle();
      return;
    }
    this.selectQuestion(newIndex);
  }

  async submit() {
    this.submitButton.setAttribute("disabled", true);
    this.submitButton.setAttribute("data-loading", true);

    const allActiveTags = [];
    this.questionCards.forEach((questionCard) => {
      questionCard.getCurrentTags().forEach((tag) => {
        allActiveTags.push(tag);
      });
    });

    const submitUrl = new URL(this.submitUrl);
    submitUrl.searchParams.set("shop", this.myshopify);

    const postData = {
      id: this.graphqlId,
      handle: this.handle,
      type: this.type,
      tags: allActiveTags,
      root: Shopify.routes.root
    }

    console.log(submitUrl)

    const submitResult = fetch(submitUrl, {
      method: "POST",
      body: JSON.stringify(postData),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const minimumWait = new Promise((resolve, reject) => {
      setTimeout(resolve, 3000);
    })

    const [ submitResultData ] = await Promise.all([submitResult, minimumWait]);


    if(!submitResultData.ok) {
      alert("Es ist ein Fehler aufgetreten. Bitte probiere es in ein paar Minuten erneut.");
      this.submitButton.removeAttribute("disabled");
      this.submitButton.setAttribute("data-loading", false);
      return;
    }

    const submitResultJson = await submitResultData.json();
    const url = submitResultJson.url;


    this.getCurrentActiveQuestion().setAttribute("data-active", false);
    this.progressBarStepLabel.setAttribute("data-active", false);
    this.progressBar.setAttribute(
      "style",
      `--progress-percentage: 100%`
    );
    this.emailPoup.open(url);
  }

  getCurrentActiveQuestion() {
    const currentActive = Array.from(this.questionCards).find(
      (card) => card.dataset.active === "true"
    );
    return currentActive;
  }

  getCurrentActiveQuestionIndex() {
    return parseInt(this.getCurrentActiveQuestion().dataset.quizQuestionIndex);
  }
}

class CustomQuizQuestionCard extends HTMLElement {
  constructor() {
    super();

    this.multichoice = this.dataset.multichoice === "true";
    this.nextButton = this.querySelector("button.full");
    this.previousButton = this.querySelector(".quiz-question-head-back");
    this.options = this.querySelectorAll("div.quiz-question-option, button.quiz-question-option");
    this.quiz = this.closest("custom-quiz");
    this.contentButton = this.querySelector(".quiz-question-content");
    this.quizContent = document.querySelector("custom-quiz-content");

    this.registerListeners();
  }

  registerListeners() {
    this.options.forEach((option) => {
      const activate = () => {
        if (!this.multichoice) {
          this.resetSelection();
        }
        this.selectOption(option);
        this.validateForm();
        if (!this.multichoice) {
          this.quiz.next();
        }
      };
      option.addEventListener("click", activate);
      option.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          activate();
        }
      });
    });

    this.nextButton?.addEventListener("click", () => {
      this.quiz.next();
    });

    this.previousButton?.addEventListener("click", () => {
      this.quiz.previous();
    });

    this.contentButton?.addEventListener("click", () => {
      this.quizContent.toggle(this.dataset.quizQuestionIndex);
    });
  }

  validateForm() {
    let isValid = this.getCurrentSelection().length > 0;

    if (isValid) {
      this.nextButton?.removeAttribute("disabled");
    } else {
      this.nextButton?.setAttribute("disabled", true);
    }

    return isValid;
  }

  getCurrentSelection() {
    return Array.from(this.options).filter(
      (option) => option.dataset.select === "true"
    );
  }

  getCurrentTags() {
    return this.getCurrentSelection().map((option) => option.dataset.tag);
  }

  selectOption(optionEl) {
    const currentOptionState = optionEl.dataset.select === "true";
    const newState = !currentOptionState;
    optionEl.setAttribute("data-select", newState);
    optionEl.setAttribute("aria-checked", newState);
  }

  resetSelection() {
    this.getCurrentSelection().forEach((option) => {
      option.setAttribute("data-select", false);
      option.setAttribute("aria-checked", false);
    });
  }
}

class CustomQuizContent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("quiz-question-content-popup") ||
        e.target.tagName === "path" ||
        e.target.tagName === "svg" ||
        e.target.hasAttribute("data-close")
      ) {
        this.closeAll();
      }
    });
  }

  closeAll() {
    this.querySelectorAll(
      ".quiz-question-content-popup-item[data-show='true']"
    ).forEach((item) => {
      this.toggle(item.dataset.quizQuestionIndex);
    });
  }

  toggle(questionIndex) {
    const item = this.querySelector(
      `.quiz-question-content-popup-item[data-quiz-question-index='${questionIndex}']`
    );
    const currentState = item.dataset.show === "true";

    item.setAttribute("data-show", "transition");
    const delay = currentState ? 300 : 50;
    setTimeout(() => {
      item.setAttribute("data-show", !currentState);
    }, delay);
  }
}

class CustomQuizEmailCard extends HTMLElement {
  constructor() {
    super();

    this.skipButton = this.querySelector(".quiz-email-skip-button");
    this.submitButton = this.querySelector(".quiz-email-submit-button");
    this.marketingInput = this.querySelector(".marketing-field input");
    this.emailInput = this.querySelector("input");
    this.backButton = this.querySelector(".quiz-email-card-head-back");

    this.klaviyoListId = this.dataset.klaviyoListId;
    this.klaviyoPublicApiKey = this.dataset.klaviyoPublicApiKey;

    this.submitButton.addEventListener("click", async () => {
      const currentEmail = this.emailInput.value;

      if(!currentEmail || currentEmail === "") {
        alert("Bitte gib eine gültige E-Mail an");
        return;
      }

      if(!this.marketingInput.checked) {
        alert("Bitte akzeptiere die Nutzungsbedingungen.");
        return;
      }

      await this.submitToKlaviyo(currentEmail);
      window.location.href = this.resultPageUrl;
    });

    console.log("HELLOWORLD")

    this.backButton.addEventListener("click", () => {
      this.setAttribute("data-active", false);
      this.closest("custom-quiz").toggle();
    })
  }

  close() {
    this.setAttribute("data-active", false);
  }

  open(resultPageUrl) {
    this.setAttribute("data-result-page-url", resultPageUrl);
    this.resultPageUrl = resultPageUrl;

    this.skipButton.href = resultPageUrl;



    this.setAttribute("data-active", "transition");
    setTimeout(() => {
      this.setAttribute("data-active", true);
    }, 50);

  }

  async submitToKlaviyo(email) {
    const klaviyoBody = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Quiz E-Mail Input",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                properties: { quizResultPage: this.dataset.resultPageUrl },
                location: {
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
              },
              meta: {
                patch_properties: {
                  append: { quizResultPage: this.dataset.resultPageUrl },
                },
              },
            },
          },
        },
        relationships: { list: { data: { type: "list", id: this.klaviyoListId } } },
      },
    };

    const fetchRes = await fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" +
        this.klaviyoPublicApiKey,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-07-15",
        },
        body: JSON.stringify(klaviyoBody),
      }
    );

    if (!fetchRes.ok) {
      console.error("Failed to submit email to Klaviyo");
    }
  }
}

customElements.define("custom-quiz-email-card", CustomQuizEmailCard);
customElements.define("custom-quiz-question-card", CustomQuizQuestionCard);
customElements.define("custom-quiz", CustomQuiz);
customElements.define("custom-quiz-content", CustomQuizContent);
